export function truncate(str,len){
  if(str && str.length > len){
    return str.slice(0,len).trim() + '...'
  } 
  return str;
}

// Known currencies keyed by both ISO code and symbol.
const KNOWN_CURRENCIES = {
  GBP: { code: "GBP", symbol: "£" }, "£": { code: "GBP", symbol: "£" },
  USD: { code: "USD", symbol: "$" }, "$": { code: "USD", symbol: "$" },
  EUR: { code: "EUR", symbol: "€" }, "€": { code: "EUR", symbol: "€" },
  JPY: { code: "JPY", symbol: "¥" }, "¥": { code: "JPY", symbol: "¥" },
  AUD: { code: "AUD", symbol: "A$" }, CAD: { code: "CAD", symbol: "C$" },
};

export const DEFAULT_CURRENCY = KNOWN_CURRENCIES.GBP;

// Turn a token from `@currency` (e.g. "USD", "$", "SEK") into { code, symbol }.
export function resolveCurrency(token){
  if (!token) return DEFAULT_CURRENCY;
  const trimmed = String(token).trim();
  const upper = trimmed.toUpperCase();
  if (KNOWN_CURRENCIES[upper]) return KNOWN_CURRENCIES[upper];
  if (KNOWN_CURRENCIES[trimmed]) return KNOWN_CURRENCIES[trimmed];
  // A 3-letter ISO code we don't have hard-coded: derive the symbol via Intl.
  if (/^[A-Za-z]{3}$/.test(trimmed)) {
    try {
      const part = new Intl.NumberFormat("en", { style: "currency", currency: upper })
        .formatToParts(0)
        .find((p) => p.type === "currency");
      return { code: upper, symbol: part ? part.value : upper };
    } catch (e) {
      return { code: upper, symbol: upper };
    }
  }
  // Otherwise treat the token as a literal symbol (no ISO code).
  return { code: null, symbol: trimmed };
};

export function formatCurrency(number, currency = DEFAULT_CURRENCY){
  const code = currency && currency.code;
  if (code) {
    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: code,
      currencyDisplay: "narrowSymbol",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(number);
  }
  // No ISO code (custom symbol): prefix the grouped number with the symbol.
  const symbol = (currency && currency.symbol) || DEFAULT_CURRENCY.symbol;
  return symbol + new Intl.NumberFormat("en-GB", { maximumFractionDigits: 0 }).format(number);
};

export function calculateEffortDays(totalPrice, dayRate){
  if (!dayRate || dayRate === 0) return null;
  return Math.round(totalPrice / dayRate);
};

export function calculateScheduleWeeks(effortDays, teamSize){
  if (!teamSize || teamSize === 0 || !effortDays) return null;
  const billableDaysPerWeek = 4;
  return Math.round(effortDays / teamSize / billableDaysPerWeek);
};

export function getPDF(){
  //console.log(ref.current)
  var div = document.getElementById("#to-print");
  //var divContents = ref.current.innerHTML
  // var printWindow = window.open('', '', 'height=400,width=800');
  // printWindow.document.write('<html><head><title>DIV Contents</title>');
  // printWindow.document.write('</head><body >');
  // printWindow.document.write(div.innerHTML);
  // printWindow.document.write('</body></html>');
  // printWindow.document.close();
  window.print();
};